import { render, staticRenderFns } from "./rawMaterialDetail.vue?vue&type=template&id=c1fc8934&scoped=true"
import script from "./rawMaterialDetail.vue?vue&type=script&lang=js"
export * from "./rawMaterialDetail.vue?vue&type=script&lang=js"
import style0 from "./rawMaterialDetail.vue?vue&type=style&index=0&id=c1fc8934&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fc8934",
  null
  
)

export default component.exports